module.exports = __webpack_public_path__ + "media/img/about/person/suren-50f683c5b023c35af806a8b1f4323f62.webp";